import { Area } from '@src/main/modules/common/area/domain/Area';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { DashboardRepository } from '@src/main/modules/common/dashboard/domain/DashboardRepository';

export const findAllDashboards = async (
  repository: DashboardRepository,
  areas: Area[],
): Promise<Dashboard[]> => await repository.findAll(areas);
